import AutoplayModel from "slotworks/model/autoplay/autoplay-model";
import { Services } from "slotworks/services/services";
import SmartUIFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import State from "slotworks/state-machine/states/state";

export default class AbstractBonus extends State {
    public onEnter() {

        SmartUIFlags.set(SmartUIFlag.BONUS, true);

        if (AutoplayModel.stopOnFeatureWin) {
            Services.autoplay.stop();
        }
    }

    public onExit() {
        SmartUIFlags.set(SmartUIFlag.BONUS, false);
    }
}
